import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

class NoActive extends Component {
  constructor(props) {
    super(props);
    //console.log("filter props", props)
    this.state = {
    }
  }

  render(){
    //console.log(list[0])
    const { classes } = this.props;
      
      return (
        <PortletContent className={classes.root} >

          <Grid container wrap="nowrap" spacing={2}>
            <Grid item xs>
              <Typography className={classes.textGrey}>Usted no tiene activa esta sección en el sitio de Reportes.
                Para mayor información, por favor póngase en contacto con su ejecutivo comercial.
                Muchas Gracias.
              </Typography>
            </Grid>
        </Grid>
        </PortletContent>
          
      );
    
  }
  
}


export default compose(withRouter, withStyles(styles))(NoActive);